import React, { Component } from 'react';
import Header from './../common/Header';
import { Button, Card } from 'reactstrap';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import Gallery from 'react-grid-gallery';
import Loader from './../common/Loader';

class UserImages extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true
        };
    }

    componentDidMount() {
        setTimeout(() => this.setState({ loading: false }), 300);
    }

    render() {
        const { loading } = this.state;
        return (
            <div>
                <Header />
                {
                    loading === true ? <Loader /> :
                        <div style={{ padding: 20 }}>
                            <Card style={styles.cardStyle}>
                                <div className="row">
                                    <div className="col" style={{ paddingLeft: 25 }}>
                                        <Button onClick={() => hashHistory.goBack()} style={styles.galleryButtonStyle}>
                                            Back
                                        </Button>
                                    </div>
                                    <div className="col">
                                        {
                                            this.props.imageList == null ? hashHistory.push('/Campaign/Gallery') :
                                                <h5 style={styles.fontStyle}>
                                                    {this.props.imageList.name}'s Images
                                                </h5>
                                        }
                                    </div>
                                    <div className="col" />
                                </div>
                                <div style={{ paddingTop: 10 }}>
                                    {
                                        this.props.imageList == null ? hashHistory.push('/Campaign/Gallery') :
                                            <Gallery images={this.props.imageList.images} enableImageSelection={false} margin={10} />
                                    }
                                </div>
                            </Card>
                        </div>
                }
            </div>
        );
    }
}

const styles = {
    galleryButtonStyle: {
        fontFamily: "Source Sans Pro-SemiBold",
        backgroundColor: '#40b508',
        borderWidth: 0,
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`
    },
    cardStyle: {
        padding: 25,
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`,
        borderColor: '#7ed321'
    },
    fontStyle: {
        fontFamily: 'Source Sans Pro-SemiBold',
        textAlign: 'center',
        paddingBottom: 10
    }
};

function mapStateToProps(state) {
    return {
        imageList: state.leaderBoardList.selectedImage
    };
}

export default connect(mapStateToProps)(UserImages);



// WEBPACK FOOTER //
// ./src/components/Campaign/UserImages.js